import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  ModalClose,
  ModalDialog,
  Typography,
} from "@mui/joy";
import {
  ApiCompetition,
  ApiCompetitionEntryDetail,
  ApiCompetitionEntryInline,
} from "griptonite-api-client";

import { useDeleteEntryMutation } from "@/hooks/competitions";

import { useModal } from "./useModal";

export default function ConfirmDeleteCompetitor({
  competition,
  entry,
  onSuccess,
}: {
  competition: ApiCompetition;
  entry: ApiCompetitionEntryInline | ApiCompetitionEntryDetail;
  onSuccess?: () => void;
}) {
  const { close } = useModal();

  const mutation = useDeleteEntryMutation();

  const onConfirm = () =>
    mutation.mutate(
      {
        userUuid: entry.user.uuid,
        competitionUuid: competition.uuid,
      },
      {
        onSuccess: () => {
          onSuccess?.();
          close();
        },
      },
    );

  return (
    <ModalDialog>
      <ModalClose />
      <DialogTitle>Are you sure?</DialogTitle>
      <DialogContent>
        <Typography sx={{ maxWidth: 350 }}>
          This user will be removed from the competition, and all their attempts and scores will be
          deleted.
          <br />
          <strong>IMPORTANT: This action cannot be undone.</strong>
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button
          color="danger"
          onClick={() => {
            onConfirm();
          }}
          sx={{ flex: 1 }}
        >
          Delete
        </Button>
        <Button color="neutral" variant="soft" onClick={close} sx={{ flex: 1 }}>
          Cancel
        </Button>
      </DialogActions>
    </ModalDialog>
  );
}
